var path = 'areas/shared/views/import_entity_dialog.html';
var html = "<div class=modal-header> <button class=close type=button data-dismiss=modal aria-hidden=true ng-click=close()>×</button> <h3>Import</h3> </div> <div class=modal-body> <error-box error=isSaving.error></error-box> <div id=scriptEditor ui-ace=\"{ mode: 'JSON' }\" ng-model=entityJson></div> <p class=tutorial>Paste the entire exported JSON object.</p> </div> <div class=modal-footer> <spin active=isSaving.busy></spin> <button class=\"btn btn-success\" ng-click=save() ng-disabled=!entityJson>Import</button> <button class=\"btn btn-default\" ng-click=close()>Close</button> </div> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/areas/shared/views/import_entity_dialog.html
// module id = 8205748407240321
// module chunks = 1